export class DayTracker {
    private map = new Map<string, HTMLButtonElement | null>();

    private static getKey(date: Date) {
        return date.toISOString().split("T")[0];
    }

    getDate(date: Date): HTMLButtonElement | null {
        return this.map.get(DayTracker.getKey(date)) || null;
    }

    setDate(date: Date, button: HTMLButtonElement | null): void {
        this.map.set(DayTracker.getKey(date), button);
    }
}
